import { LOAD_ORDER_TYPES_SUCCESS, CLEAR_ORDER_TYPES } from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_ORDER_TYPES_SUCCESS:
            return action.payload;
        case CLEAR_ORDER_TYPES:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/OrderTypesReducer.js